import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true,
}

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    set: (state, action) => {
      state.sidebarShow = action.payload
    },
  },
})

export default sidebarSlice.reducer
export const { set } = sidebarSlice.actions
